export const isUrl = (str: string): boolean => {
    return !!str && (str.startsWith('http://') || str.startsWith('https://'));
};
